import { useQuery } from 'react-query';
import { formatString, getSearchBody, mapKeyToVal } from 'newJs/utils/mapiQueries';
import {history, setPageTitle} from 'newJs/utils';
import {useMailListPermanentStore, useMailListStore} from 'state/mailListState';
import {useLocation} from 'react-router-dom';

const fetchData = (name, list) => {
    if (Object.hasOwnProperty.call(list, name)) {
        return list[name];
    }
    throw new Error(`No fetcher found for ${name}`);
};

const fetchersList = {
    mailList: async ({ queryKey }) => {
        const [/*key*/, fetch, params] = queryKey;
        const { requestUrl, queryParams } = params;
        const { query, folder, ...otherParams } = queryParams;
        const endpoint = new URL(requestUrl);
        if (
            typeof queryParams === 'object'
            && Object.keys(queryParams).length > 0
        ) {
            const search = new URLSearchParams(otherParams);
            const queryString = formatString.query(query);
            search.append('query', queryString);
            endpoint.search = search.toString();
        }

        const excludedPages = ['message', 'page', 'send', 'demo', 'bx_preview', 'advancedSearch']; // no need to page reload on this pages, remove when all pages will moved to react router
        if (!excludedPages.some(page => window.location.href.includes(page) || window.location.search.includes('demo')) && window.location.search.includes('&ts')) {
            const encodeFolder = encodeURIComponent(folder);
            //we add timestamp becooooz of back-forward cache issues
            const ts = Date.now();

            // Get the current search parameters
            const searchParams = new URLSearchParams(window.location.search);

            // Append or update the 'mailbox' and 'ts' parameters
            searchParams.set('mailbox', encodeFolder);
            searchParams.set('ts', ts);

            // Use history.push to update the URL without overwriting other parameters
            history.push({
                pathname: '/mailbox',
                search: searchParams.toString()
            });
        }
        if (window.location.href.includes('&uniq')) {
            const regex = new RegExp('&uniq=.+');
            const pathname = window.location.href.replace(regex, '');
            history.push({ pathname });
        }

        return await fetch({
            cache: false,
            url: endpoint.toString()
        });
    },
    search: async ({ queryKey }) => {
        const [/*key*/, fetch, params] = queryKey;
        const { requestUrl,  queryParams: { body} } = params;
        const endpoint = new URL(requestUrl);
        //decode folders, to return correct search results
        const decodedFolder =decodeURIComponent(body.folders[0]);
        const searchParams = new URLSearchParams(window.location.search);
        body.folders = [decodedFolder];
        const currentUrl = new URL(window.location.href);
        if (currentUrl.search.includes('&uniq')) {
            const regex = new RegExp('&uniq=.+');
            const pathname = window.location.href.replace(regex, '');
            history.push({ pathname });
        }
        // advanced search need update folders to check where to search
        if (searchParams.get('type') === 'advancedSearch') {
            // MAIL-6421 - get all folders from url
            const foldersInUrl = {
                folders: searchParams.getAll('inFolders').length
                    ? searchParams.getAll('inFolders')
                    : ['ALL'],
            };

            // set keyword or subject param into subject
            const subject = searchParams.get('keyword') ?? searchParams.get('params[subject]');
            if (subject) foldersInUrl.subject = subject;

            // get all other params and set them as body params with values
            for (const [k, v] of searchParams) {
                const m = /^params\[(.+)\]$/.exec(k);
                if (m && v && m[1] !== 'subject') {
                    let value = v;
                    // MAIL-6421 - if there is boolean values, then pass them in correct type
                    if (v === 'true') value = true;
                    else if (v === 'false') value = false;

                    foldersInUrl[m[1]] = value;
                }
            }
            // MAIL-6421 - now update params
            Object.assign(body, foldersInUrl);

            if (searchParams.get('params[label]')) {
                delete body.subject;
                Object.assign(body, {
                    label: searchParams.get('params[label]')
                });
            }
        }
        // execute only if is used advanced search and user tries to sort messages
        if (( searchParams.get('type') === 'advancedSearch' || searchParams.get('type') === 'fromAddress') && searchParams.has('sortBy')) {
            // const { sortBy, sortDir } = params.search || {};
            const sortParams = {
                sortDirection: searchParams.has('sortDir') ? searchParams.get('sortDir') : 'desc',
                sortFieldId: searchParams.has('sortBy') ? searchParams.get('sortBy') : '0',
            };
            const sortTerms = formatString.searchSortTerms(mapKeyToVal(sortParams));
            Object.assign(body, {
                sortTerms,
            });
        }

        if (searchParams.get('type') === 'thread') {
            Object.assign(body, {
                folders: ['ALL'],
                messageIds : [`${searchParams.get('keyword')}`]
            });

            // const [folder] = params.search.inFolders;
            // const encodeFolder = encodeURIComponent(folder);
            // const hash = window.location.hash;
            // const excludedPages = ['message'];
            // if (!excludedPages.some(page => window.location.href.includes(page))) {
            //     history.push({
            //         pathname: '/mailbox',
            //         search: `${serialiseSearchObjectToString(params.search)}&mailbox=${encodeFolder}${hash.replace('#move-to-folder', '')}`
            //     });
            // }
            // if (window.location.href.includes('&uniq')) {
            //     const regex = new RegExp('&uniq=.+');
            //     const pathname = window.location.href.replace(regex, '');
            //     history.push({ pathname });
            // }
        }
        if(searchParams.get('type') === 'keyword') {
            Object.assign(body, {
                subject: searchParams.get('keyword'),
                from: searchParams.get('keyword'),
                type:'quick'
            });
        }

        return await fetch({
            cache: false,
            contentType: 'application/json',
            data: JSON.stringify(body),
            type: 'POST',
            url: endpoint.toString()
        });
    },
    // // FIXME: removed because MAPI-819, now can pass messageIds pass in search to get sortable and fīlterable thread queries
    // thread: async ({ queryKey }) => {
    //     const [/*key*/, fetch, params] = queryKey;
    //     const { search } = params;
    //     const [folder] = search.inFolders;
    //     const encodeFolder = encodeURIComponent(folder);
    //     const hash = window.location.hash;
    //     const endpoint = new URL(params.requestUrl);
    //
    //     const excludedPages = ['message'];
    //     if (!excludedPages.some(page => window.location.href.includes(page))) {
    //         history.push({
    //             pathname: '/mailbox',
    //             search: `${serialiseSearchObjectToString(search)}&mailbox=${encodeFolder}${hash.replace('#move-to-folder', '')}`
    //         });
    //     }
    //     if (window.location.href.includes('&uniq')) {
    //         const regex = new RegExp('&uniq=.+');
    //         const pathname = window.location.href.replace(regex, '');
    //         history.push({ pathname });
    //     }
    //
    //     return await fetch({
    //         cache: false,
    //         url: endpoint.toString()
    //     });
    // }
};

const queryTypesList = (params, MAPI) => {
    const { sortParams, ...otherParams } = params;
    return {
        search: () => {
            const searchParams = new URLSearchParams(window.location.search);
            const sortTerms = formatString.searchSortTerms(mapKeyToVal(sortParams));
            const searchObj = Object.fromEntries(searchParams.entries());
            let requestUrl = MAPI.v2.search(otherParams);
            const bodyPrepare = {...searchObj, inFolders: searchParams.getAll('inFolders')};
            const queryParams = { body: getSearchBody(bodyPrepare, sortTerms) };
            // Remove 'offset' from requestUrl if conditions match
            const url = new URL(requestUrl);
            const filterMapping = {
                flagged: { important: true },
                unflagged: { important: false },
                answered: { answered: true },
                unanswered: { answered: false },
                seen: { seen: true },
                unseen: { seen: false },
                forwarded: { forwarded: true },
                unforwarded: { forwarded: false },
                messageIds : searchParams.has('type') === 'thread' ? [`${searchParams.get('keyword')}`] : null //THREADS
            };

            if (searchParams.get('type') === 'keyword' && !searchParams.has('page')) {
                url.searchParams.delete('offset');
            }

            requestUrl = url.toString();

            // Apply filters to the query body
            if (searchParams.has('filterBy')) {
                Object.assign(queryParams.body, filterMapping[searchParams.get('filterBy')]);
            }
            // Handle 'fromAddress' type search
            if (searchParams.get('type') === 'fromAddress') {
                Object.assign(queryParams.body, {
                    folders: [searchParams.get('mailbox')],
                    from: searchParams.get('keyword')
                });
            }
            // MAIL-6250 add keyword to search in 'to' field (except when using advanced search)
            // MAIL-6292 add that quick search sets 'to' ONLY for 'sent/draft/outbox' folders, otherwise search with 'from'
            const inFolders = searchParams.getAll('inFolders') || '';
            const foldersToCheck = ['sent', 'draft', 'outbox'];
            if (searchParams.get('type') !== 'advancedSearch' &&  foldersToCheck.some(folder =>
                inFolders.some(inFolder => inFolder.toLowerCase().includes(folder))
            )) {
                Object.assign(queryParams.body, {
                    to: searchParams.get('keyword')
                });
                // MAIL-6292 Remove the 'from' property if it exists (search only with 'TO' in 'sent' folder)
                delete queryParams.body.from;
            }
            return [
                ['mailList', MAPI.fetch, { requestUrl, queryParams, searchParams }],
                'search'
            ];
        },
        // FIXME: removed because MAPI-819, now can pass messageIds pass in search to get sortable and fīlterable thread queries
        // thread: () => {
        //     const [folder] = search.inFolders;
        //     const requestUrl = MAPI.v2.messagesThread(folder, search.keyword);
        //
        //     return [
        //         ['mailList', MAPI.fetch, { requestUrl, search }],
        //         'thread'
        //     ];
        // },
        default: () => {
            const searchParams = new URLSearchParams(window.location.search);
            const folder = searchParams.get('mailbox') ?  searchParams.get('mailbox') : 'INBOX' ;
            const requestUrl = MAPI.v2.messages(folder);
            const filterBy = searchParams.get('filterBy');
            // Determine the search term
            const term = (() => {
                if (!filterBy) return '["ALL"]';
                const upperFilter = `$${filterBy.toUpperCase()}`;
                if (filterBy === 'forwarded') return `["KEYWORD","${upperFilter}"]`;
                if (filterBy === 'unforwarded') return `["NOT","KEYWORD","${upperFilter.replace('UN','')}"]`;
                return `["${filterBy}"]`;
            })();
            const queryParams = {
                query: {
                    searchTerms:term,
                    sortTerms: formatString.sortTerms(mapKeyToVal(sortParams))
                },
                folder,
                ...otherParams
            };
            return [
                ['mailList', MAPI.fetch, { requestUrl, queryParams }],
                'mailList'
            ];
        }
    };
};

//MAIL-6269 - build maillist query (can call it fŗom components)
export const getMailListQuery = (params, MAPI) => {
    const searchParams = new URLSearchParams(window.location.search);
    const queriesList = queryTypesList(params, MAPI);
    const searchTypes = ['advancedSearch', 'keyword', 'fromAddress', 'toAddress', 'unSeen', 'thread'];
    let queryArgs = queriesList.default();
    if (
        searchTypes.includes(searchParams.get('type')) ||
        searchParams.has('fromAddress') ||
        searchParams.has('threads')
    ) {
        queryArgs = queriesList.search();
    }

    const [queryKey, queryFnName] = queryArgs;
    const queryFn = fetchData(queryFnName, fetchersList);

    return { queryKey, queryFn };
};

export default (params, MAPI, { enabled } = { enabled: true }) => {
    const location = useLocation();
    const setMailListData = useMailListStore((state) => state.setData);
    const memSortFieldId = useMailListPermanentStore((state) => state.sortFieldId);
    const searchParams = new URLSearchParams(location.search);
    const currentPage = Number(searchParams.get('page')) || 1;
    const sortDirection = searchParams.get('sortDir') || 'desc';
    const sortFieldId = searchParams.get('sortBy') ? searchParams.get('sortBy') : memSortFieldId;
    const { queryKey, queryFn } = getMailListQuery(params, MAPI);
    return useQuery(queryKey, queryFn, {
        retry: 2,
        enabled,
        onSuccess: (res) => {
            setMailListData(res, currentPage, sortDirection, sortFieldId);
            // MAIL-6418 - give latest number of unread messages
            location?.pathname.includes('mailbox') && setPageTitle(res.unread, 'mailbox');
        },
    });
};
